import styled from "@emotion/styled";
import { GrButton, palette } from "@jnpmedi/grebob";
import { Link } from "react-router-dom";
import { InformationGuide } from "@newComponents/layout/InformationGuide";

export function ErrorLayout() {
  return (
    <InformationGuide
      style={{ height: "100%" }}
      title="Page Not Found"
      description=""
      confirmButton={
        <GoHomeButton>
          <Link to="/">Go Home</Link>
        </GoHomeButton>
      }
    />
  );
}

const GoHomeButton = styled(GrButton)`
  a {
    color: ${palette["white"]};
    text-decoration: none;
  }
`;
